import DayjsExtended from "@logic/DayjsExtended";

export const POST_APPROVAL_MINUTES_AHEAD = 15;
export const POST_SCHEDULE_MAX_DAYS_AHEAD = 45;
export const MS_TO_SHOW_WARNING = 7000;

function isValidTimezoneId(timeZoneId: string | null | undefined): timeZoneId is string {
  if (!timeZoneId || !timeZoneId.trim()) return false;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: timeZoneId.trim() });
    return true;
  } catch {
    return false;
  }
}

/** When `timeZoneId` is set (IANA), compares using that zone for the scheduled local wall time vs current instant + buffer. Otherwise uses the browser local zone. */
export function isScheduledDateTooSoon(localDateTime: string, timeZoneId?: string | null): boolean {
  const cutoff = DayjsExtended().add(POST_APPROVAL_MINUTES_AHEAD, "minutes");
  if (isValidTimezoneId(timeZoneId)) {
    const scheduled = DayjsExtended.tz(localDateTime, timeZoneId.trim());
    return scheduled.isSameOrBefore(cutoff);
  }
  return DayjsExtended(localDateTime).isSameOrBefore(cutoff);
}

/** Min selectable schedule time as `YYYY-MM-DDTHH:mm` in `timeZoneId` when provided (customer posting zone); otherwise browser local. */
export function getPostScheduleMinDate(timeZoneId?: string | null): string {
  if (isValidTimezoneId(timeZoneId)) {
    return DayjsExtended().add(POST_APPROVAL_MINUTES_AHEAD, "minutes").tz(timeZoneId.trim()).format("YYYY-MM-DDTHH:mm");
  }
  return DayjsExtended().add(POST_APPROVAL_MINUTES_AHEAD, "minutes").format("YYYY-MM-DDTHH:mm");
}

export function getPostScheduleMaxDate(timeZoneId?: string | null): string {
  if (isValidTimezoneId(timeZoneId)) {
    return DayjsExtended().add(POST_SCHEDULE_MAX_DAYS_AHEAD, "day").tz(timeZoneId.trim()).format("YYYY-MM-DDTHH:mm");
  }
  return DayjsExtended().add(POST_SCHEDULE_MAX_DAYS_AHEAD, "day").format("YYYY-MM-DDTHH:mm");
}
